export default __webpack_public_path__ + "271691deaabe64e5c1fe366c8bff14cd.png";